import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import './ChatHeader.scss';

const ChatHeader = ({ onClose, isINES }) => {
  return (
    <div className={`chat-header ${isINES ? 'chat-header--ines' : ''}`}>
      <div className="chat-header__title">
        <span className="material-symbols-rounded">smart_toy</span>
        <span>{I18n.t('chatbot.title')}</span>
      </div>
      <button
        className="chat-header__close"
        onClick={onClose}
        aria-label={I18n.t('chatbot.close')}
      >
        <span className="material-symbols-rounded">close</span>
      </button>
    </div>
  );
};

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  isINES: PropTypes.bool,
};

export default ChatHeader;
